import axiosInstance from '../../axios/axiosInstance'
import { apiErrorCode, apiErrorText } from '../../i18n/apiError'
import { SET_ERRORS, SET_CORRECTIONS, SET_CURRENT_CORRECTION } from '../types'
import store from '../store'

export const setCurrentCorrection = (correction: any) => {
  store.dispatch({
    type: SET_CURRENT_CORRECTION,
    payload: correction,
  })
}

export const setCorrections = (corrections: any) => {
  store.dispatch({
    type: SET_CORRECTIONS,
    payload: corrections,
  })
}

export const submitCorrection = async (
  storyId: string,
  correctedAnswer: string,
  memberId: string,
  uploadKey: string,
) => {
  const content = {
    storyId,
    memberId,
    correctedRecordingUrl: uploadKey,
    correctedAnswer,
  }
  try {
    const res = await axiosInstance.post(`story-correction`, content)
    const data = res?.data
    if (data && !data.status && Object.keys(data) && Object.keys(data).length > 0) {
      return data
    } else {
      store.dispatch({
        type: SET_ERRORS,
        payload: data.message.message,
      })
      throw data.message.message
    }
  } catch (error: any) {
    // If error is from axios or from above throw
    let errorMessage = error
    const shown = apiErrorCode(error) ? apiErrorText(error) : error?.response?.data?.message?.message
    if (shown) {
      errorMessage = shown
      store.dispatch({
        type: SET_ERRORS,
        payload: errorMessage,
      })
    }
    throw errorMessage
  }
}

export const getStoryCorrections = async (page: number, perPage: number, search: string) => {
  let queryReq = `story-corrections?page=${page}&par_page=${perPage}`
  if (search && search !== '') {
    queryReq = `${queryReq}&search=${search}`
  }
  try {
    const res = await axiosInstance.get(queryReq)
    const data = res?.data
    if (data && Object.keys(data) && Object.keys(data).length > 0) {
      return data?.data
    } else {
      store.dispatch({
        type: SET_ERRORS,
        payload: data.message.message,
      })
      throw data.message.message
    }
  } catch (error: any) {
    let errorMessage = error
    if (errorMessage?.response?.data?.status === 403) {
      window.location.href = '/'
      return
    }

    const shown = apiErrorCode(error) ? apiErrorText(error) : error?.response?.data?.message?.message
    if (shown) {
      errorMessage = shown
      store.dispatch({
        type: SET_ERRORS,
        payload: errorMessage,
      })
    }
    throw errorMessage
  }
}
